import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

import { border } from 'styles'

import MoreMenuItem from './MoreMenuItem'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const Input = styled.div`
  cursor: pointer;
  padding: 10px;
  margin: 0 18px 0 6px;
  line-height: 0;
`

const Dropdown = styled.div`
  position: absolute;
  z-index: 1;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  top: calc(100% - 12px);
  right: 15px;
  width: 150px;
`

const Menu = styled.div`
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    border-bottom: ${border};
  }
`

const MenuTop = styled.img`
  position: absolute;
  z-index: -1;
  right: 5px;
  top: -18.6px;
  user-drag: none;
`

class MoreMenu extends React.Component {
  state = {
    isOpen: false,
    activeIndex: undefined,
  }

  closeMenu = () => this.setState({ isOpen: false, activeIndex: undefined })

  onKeyDown = e => {
    if (this.state.isOpen) {
      switch (e.key) {
        case ' ':
        case 'Escape':
          e.preventDefault()
          this.closeMenu()
          break
        case 'ArrowDown':
          e.preventDefault()
          this.setState(state => ({
            activeIndex: (state.activeIndex + 1) % this.props.items.length,
          }))
          break
        case 'ArrowUp':
          e.preventDefault()
          this.setState(state => ({
            activeIndex:
              (state.activeIndex + this.props.items.length - 1) %
              this.props.items.length,
          }))
          break
        case 'Enter':
          e.preventDefault()
          const item = this.props.items[this.state.activeIndex]
          if (item.onClick) {
            item.onClick()
          } else if (item.link) {
            this.props.history.push(item.link)
          }
          this.closeMenu()
          break
        default:
      }
    } else {
      if ([' ', 'Enter', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
        e.preventDefault()
        this.setState({
          isOpen: true,
          activeIndex: 0,
        })
      }
    }
  }

  render() {
    return (
      <Wrapper>
        <Input
          onClick={() => this.setState(state => ({ isOpen: !state.isOpen }))}
          onBlur={this.closeMenu}
          onKeyDown={this.onKeyDown}
          tabIndex="0">
          <img src={this.props.image || '/icons/more.svg'} alt="" />
        </Input>
        {this.state.isOpen && (
          <Dropdown>
            <MenuTop src="/icons/menu-top.svg" alt="" />
            <Menu>
              {this.props.items.map((menuItem, index) => (
                <MoreMenuItem
                  key={index}
                  {...menuItem}
                  active={this.state.activeIndex === index}
                />
              ))}
            </Menu>
          </Dropdown>
        )}
      </Wrapper>
    )
  }
}

export default withRouter(MoreMenu)



// WEBPACK FOOTER //
// ./src/components/Header/MoreMenu/index.js